// Actions
import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for TodoStore, for use in the registry */ export const TodoStoreActionTypes = [
    ActionType.FetchEntityCollectionSucceededAction
];
